import { useState, useEffect } from "react";
import ReactGA from "react-ga";
import makeStyles from "@mui/styles/makeStyles";
import { Link, useNavigate, useLocation } from "react-router-dom";

import { useForm, Controller } from "react-hook-form";

// components
import Container from "@mui/material/Container";
import CodeInput from "components/shared/CodeInput";
import Grid from "@mui/material/Grid";
import LoadingButton from "components/shared/LoadingButton";
import Typography from "components/shared/Typography";
import Input from "components/shared/Input";
import Lottie from "react-lottie";
import { isTokenExpired } from "utils";
// assets
// import requestOTPImage from 'assets/images/customer/requestOTP.png';
// import submitOTPImage from 'assets/images/customer/submitOTP.png';
import background from "assets/phase7/otpback.jpg";
import header from "assets/phase7/otpheader.png";

import otpAnimation from "assets/lotties/rightPanelLoading.json";

// constants
import { SPACING, SPACING_THIRD } from "constants/spacing";

import { MOBILE_REGEX } from "constants/regex";

//utils
import { digitsFaToEn } from "persian-tools2";
import { useRequestOTP, useSubmitOTP } from "hooks/auth";

//libs
import {
  getRefreshTokenCookie,
  removeOTPTokenCookie,
  setRefreshTokenCookie,
  setSignupTokenCookie,
} from "lib/Storage";


function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    // minHeight: '100vh',
    minHeight: "fit-content",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  leftPanel: {
    width: "100%",
    // minHeight: '100vh',
    minHeight: "fit-content",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  form: {
    width: "100%",
  },
  buttonWraper: {
    marginTop: theme.spacing(SPACING),
  },
  monkey: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  phoneInput: {
    "& .MuiInputBase-input::placeholder": {
      textAlign: "center",
    },
    "& .MuiInputBase-input": {
      textAlign: "right",
      direction: "rtl",
    },
  },
  largeLabel: {
    marginTop: 35,
    fontSize: theme.typography.pxToRem(25),
    height: "75%",
    "&:disabled": {
      color: "#959595",
    },
  },
  wholepage: {
    width: "100vw",
    height: "100vh",
    position: "fixed",
    top: 0,
    backgroundImage: `url(${background})`,
    backgroundSize: "auto 100%",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center bottom",
    overflow: "hidden",

    fontFamily: "Shabnam, Poppins, sans-serif !important",
    direction: "rtl",
    // backgroundColor:"#e5e5e5",
  },
  mainContainer: {
    backgroundColor: "#f5f5f5",
    // borderRadius:"10px",
    position: "relative",
    top: "25%",
    padding: "0px",
    borderRadius: "15px",

    [theme.breakpoints.down("sm")]: {
      backgroundColor: "#f5f5f59",
      top: "15%",
    },
  },
}));

/**
 * @component Otp
 */
function Otp() {
  const classes = useStyles();
  const navigate = useNavigate();
  const [pinCode, setPinCode] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [step, setStep] = useState("enterPhone");
  const [hasError, setHasError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const { mutate: mutateRequest, loading: isLoadingRequest } = useRequestOTP();
  const { mutate: mutateSubmit, loading: isLoadingSubmit } = useSubmitOTP();


  const query = useQuery();

  useEffect(() => {
    const refreshToken = query.get('t');
    if (refreshToken && !isTokenExpired(refreshToken)) {
        if(!isTokenExpired(refreshToken))
      setRefreshTokenCookie(refreshToken);
      const newUrl = window.location.origin + window.location.pathname;
      window.history.replaceState({}, document.title, newUrl);
      window.location.reload();
    }
  }, [query]);
  useEffect(()=>{
    if (!!getRefreshTokenCookie()) navigate("/");
  },[navigate])

  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);

  const onSubmitRequest = (e) => {
    // e.preventDefault();
    let enPhoneNumber = digitsFaToEn(e.phoneNumber);
    setPhoneNumber(e.phoneNumber);

    mutateRequest(enPhoneNumber, {
      onSuccess: (data) => {
        if (data?.status === "OK") {
          setStep("enterOTP");
        } else if (data?.status === "ALREADY REQUESTED!") {
          setHasError(true);
          setErrorMessage(
            `از اس ام اس قبلیمون به شما کمتر از ۳ دقیقه گذشته! لطفا بعدا امتحان کنین.`
          );
        } else {
          // console.log(data?.status)
          setHasError(true);
          setErrorMessage(
            "شماره ای که وارد کردین، هنوز وارد لیست نشده! باید یکم صبر کنید تا نوبتتون برسه. برای اطلاعات بیشتر به آیدی @timelinemaster داخل تلگرام پیغام بدید."
          );
        }
      },
      onError: (data) => {
        setHasError(true);
        setErrorMessage(
          "شماره ای که وارد کردین، هنوز وارد لیست نشده! باید یکم صبر کنید تا نوبتتون برسه. برای اطلاعات بیشتر به آیدی @timelinemaster داخل تلگرام پیغام بدید."
        );
      },
    });

    // history.push('/auth/complete-profile');
  };
  const onSubmitSubmit = (e) => {
    e.preventDefault();
    // console.log(pinCode);
    let enPinCode = digitsFaToEn(pinCode);
    mutateSubmit(enPinCode, {
      onSuccess: (data) => {
        if (data?.status === "OK") {
          removeOTPTokenCookie();
          setRefreshTokenCookie(data?.refreshToken);
          //   console.log(data);
          navigate("/");
        }
      },
    });

    // history.push('/auth/complete-profile');
  };

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      phoneNumber: "",
    },
  });

  const validateRegex = (value) => {
    const innerValue = digitsFaToEn(value);
    if (!MOBILE_REGEX.test(innerValue)) {
      return "شماره موبایل نامعتبر است";
    }
    return true;
  };

  if (!!getRefreshTokenCookie()) navigate("/");

  return (!getRefreshTokenCookie() && <div className={classes.wholepage} dir="rtl">
      <Container maxWidth="sm" className={classes.mainContainer}>
        <Grid container spacing={0}>
          {/* <div className={classes.root}> */}
          <Grid item xs={12} className={classes.root}>
            <Grid
              container
              style={{
                position: "absolute",
                width: "100%", 
              }}
            >
              <Grid item xs={1} md={3}>
                &nbsp;
              </Grid>
              <Grid item xs={10} md={6}>
                <img
                  style={{
                    width: "100%",
                    maxWidth: "600px",
                    position: "relative",
                    // right:"25%",
                  }}
                  src={header}
                  alt="otp"
                />
              </Grid>
              <Grid item xs={1} md={3}>
                &nbsp;
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} className={classes.root}>
            {step === "enterPhone" && (
              <form
                noValidate
                onSubmit={handleSubmit(onSubmitRequest)}
                className={classes.form}
              >
                <Grid
                  container
                  spacing={SPACING_THIRD}
                  style={{ padding: "15%" }}
                >
                  <Grid item xs={12} style={{ paddingTop: "10%" }}>
                    <Typography align="center" variant="h2" dir="rtl">
                      به تایم لاین خوش اومدید!
                    </Typography>
                  </Grid>

                  <Grid item xs={12}>
                    {/* <CodeInput fields="5" noWrap value={pinCode} onChange={setPinCode} /> */}
                    <Controller
                      name="phoneNumber"
                      rules={{ required: true, validate: validateRegex }}
                      control={control}
                      render={({ field }) => (
                        <Input
                          label="شماره تلفن"
                          type="tel"
                          fullWidth
                          InputLabelProps={{
                            shrink: true,
                          }}
                          placeholder="لطفا شماره موبایل خودتون رو وارد کنید"
                          className={classes.phoneInput}
                          textAlign="center"
                          helperText={
                            errors?.phoneNumber &&
                            errors?.phoneNumber?.type === "validate" ? (
                              <Typography
                                variant="body2"
                                component="span"
                                color="error"
                                locale="en"
                              >
                                {errors?.phoneNumber?.message}
                              </Typography>
                            ) : errors?.phoneNumber?.type === "required" ? (
                              <Typography
                                variant="body2"
                                component="span"
                                color="error"
                              >
                                وارد کردن این فیلد ضررویه
                              </Typography>
                            ) : null
                          }
                          {...field}
                        />
                      )}
                    />
                    {/* <Input value={phoneNumber} onChange={setPhoneNumber} fullWidth label="لطفا شماره موبایل خود را وارد کنید" className={classes.phoneInput} /> */}
                  </Grid>
                  {hasError && (
                    <Grid item xs={12} className={classes.errorPane}>
                      <Typography dir="rtl">{errorMessage}</Typography>
                    </Grid>
                  )}
                  <Grid item xs={12} className={classes.buttonWraper}>
                    <LoadingButton
                      className={classes.largeLabel}
                      type="submit"
                      // size="small"
                      fullWidth
                      variant="contained"
                      color="primary"
                      disabled={errors?.phoneNumber}
                      loading={isLoadingRequest}
                    >
                      دریافت کد
                    </LoadingButton>
                  </Grid>
                </Grid>
              </form>
            )}
            {step === "enterOTP" && (
              <form
                noValidate
                onSubmit={onSubmitSubmit}
                className={classes.form}
              >
                <Grid
                  container
                  spacing={SPACING_THIRD}
                  style={{ padding: "15%" }}
                >
                  {/* <Grid item xs={12} style={{ marginBottom: "-15%" }}>
                    <Lottie
                      options={{
                        loop: true,
                        autoplay: true,
                        animationData: otpAnimation,
                        rendererSettings: {
                          preserveAspectRatio: "xMidYMid slice",
                        },
                        // initialSegment: [11, 121],
                      }}
                      height={"70%"}
                      width={"80%"}
                    />
                  </Grid> */}
                  <Grid item xs={12}>
                    <Typography align="center">
                      {`کد یکبار مصرف به شماره ${phoneNumber} ارسال شد`}
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <CodeInput
                      fields="5"
                      noWrap
                      value={pinCode}
                      onChange={setPinCode}
                      type="code"
                    />
                  </Grid>
                  <Grid item xs={12} className={classes.buttonWraper}>
                    <div
                      onClick={() => setStep("enterPhone")}
                      style={{ textAlign: "center" }}
                    >
                      <Typography
                        gutterBottom
                        component={Link}
                        to="#"
                        color="primary"
                        align="center"
                      >
                        ویرایش شماره
                      </Typography>
                    </div>
                    <LoadingButton
                      className={classes.largeLabel}
                      type="submit"
                      // size="small"
                      fullWidth
                      variant="contained"
                      color="primary"
                      disabled={errors?.phoneNumber}
                      loading={isLoadingSubmit}
                    >
                      تایید
                    </LoadingButton>
                  </Grid>
                </Grid>
              </form>
            )}
          </Grid>

          {/* <Grid item xs={12} md={6} className={classes.leftPanel}>
          {step === 'enterPhone' && <img src={requestOTPImage} alt="left" height={'80%'} />}
          {step === 'enterOTP' && <img src={submitOTPImage} alt="left" height={'80%'} />}

        </Grid> */}
          {/* </div> */}
        </Grid>
      </Container>
    </div> )
  
}

export default Otp;
